// extracted by mini-css-extract-plugin
module.exports = {"faq-container":"personal-plan-faq_faq-container__aTpAn"};